import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TUpdateAccrualPolicyWorkersRequestSchema,
  TUpdateAccrualPolicyWorkersResponseSchema,
} from "./updateAccrualPolicyWorkers.schema";

export const updateAccrualPolicyWorkers = (axios: IAxiosInstance) => {
  return async ({
    id,
    companyID,
    add_employees,
    remove_employees,
  }: TUpdateAccrualPolicyWorkersRequestSchema) => {
    const { data } = await axios.noRetry.patch<
      IApiResponse<TUpdateAccrualPolicyWorkersResponseSchema>
    >(`/accrual-policies/${id}/workers?companyID=${companyID}`, {
      add_employees,
      remove_employees,
    });

    if (data.success) {
      return data.data;
    }

    throw new Error("Something went wrong");
  };
};
